import type {PropsWithChildren} from 'react';
import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import styles from './root.module.css';

type Props = PropsWithChildren;

export function MediaUserLoginGuideRoot({children, ...props}: Props) {
  return (
    <div
      className={clsx(
        styles.root,
        isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
